import { FormControl, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import cn from 'classnames';
import { OddsChangeRules } from 'features/coupon/interface';
import { getUserOddsChangeRules } from 'features/coupon/utility';
import React, { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
	className?: string;
	handleOddsChangeOption: (e: any) => void;
}

const ChangeOddsPriority: React.FC<Props> = ({ handleOddsChangeOption }) => {
	const { t } = useTranslation();
	const oddsChangeKeys = getUserOddsChangeRules();
	const radioValue = Object.entries(oddsChangeKeys).find(([_, value]) => value === true)?.[0];

	return (
		<div className="odds-mod-selector bet-coupon b-radius--4 flex flex--row justify__content--end align__items--start text--primary pointer">
			<FormControl component="fieldset" className={cn('field-options', {})}>
				<RadioGroup
					aria-label="oddsChangeRule"
					name="oddsChangeRule"
					value={radioValue}
					onChange={(e) => {
						handleOddsChangeOption(e.target.value);
					}}
				>
					<FormControlLabel
						value={OddsChangeRules.ACCEPT_ALL_ODDS_CHANGES}
						control={
							<Radio
								className="customeRadio"
								inputProps={{ 'data-cy': 'betslip-acceptance-radio' } as InputHTMLAttributes<HTMLInputElement>}
							/>
						}
						label={t('ACCEPT_ANY_RATE_CHANGE')}
						labelPlacement="end"
					/>
					<FormControlLabel
						value={OddsChangeRules.ACCEPT_HIGHER_ODDS_CHANGES}
						control={
							<Radio
								className="customeRadio"
								inputProps={{ 'data-cy': 'betslip-acceptance-radio' } as InputHTMLAttributes<HTMLInputElement>}
							/>
						}
						label={t('ONLY_ACCEPT_HIGHER_RATES')}
						labelPlacement="end"
					/>
					<FormControlLabel
						value={OddsChangeRules.ACCEPT_NO_ODDS_CHANGES}
						control={
							<Radio
								className="customeRadio"
								inputProps={{ 'data-cy': 'betslip-acceptance-radio' } as InputHTMLAttributes<HTMLInputElement>}
							/>
						}
						label={t('DONOT_ACCEPT_ANY_ODDS')}
						labelPlacement="end"
					/>
				</RadioGroup>
			</FormControl>
		</div>
	);
};

export default ChangeOddsPriority;
